import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';

export const needsComment = (orderStatus, serviceTypeId) => {
  if (orderStatus === 'NoAccess' || orderStatus === 'Complete') {
    return true;
  }

  if (!serviceTypeId) {
    return false;
  }

  if  (serviceTypeId.toLowerCase().includes('sr') || serviceTypeId.toLowerCase().includes('di')) {
    return false;
  } else {
    return true;
  }
};

export default (state, orderId) => {

  let currentValidation = state.getIn(['workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation']) || initialStepValidation;
  const serviceTypeId = state.getIn([
    'workOrderDetails',
    orderId,
    'schedulingSystemDetails',
    'details',
    'serviceOrderInfoV2',
    'serviceTypeId'
  ]);

  currentValidation = currentValidation.setIn([
    'comment', 'isValid'
  ], true).setIn([
    'comment', 'message'
  ], null);

  const orderStatus = state.getIn([
    'workOrderDetails',
    orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'orderStatus'
  ]);

  const comment = state.getIn([
    'workOrderDetails',
    orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'commentRequest',
    'comment'
  ]);

  if (needsComment(orderStatus, serviceTypeId) && comment && comment.length <= 2) {

    currentValidation = currentValidation.setIn([
      'comment', 'isValid'
    ], false).setIn([
      'comment', 'message'
    ], 'Comment must be at least three characters.');
  }

  if (needsComment(orderStatus, serviceTypeId) && !comment) {
    currentValidation = currentValidation.setIn([
      'comment', 'isValid'
    ], false).setIn([
      'comment', 'message'
    ], 'A comment is required');
  }

  if (orderStatus === 'NoAccess' && !comment) {

    currentValidation = currentValidation.setIn([
      'comment', 'isValid'
    ], false).setIn([
      'comment', 'message'
    ], 'No Access Requires a comment.');
  }

  if (orderStatus === 'Complete' && !comment) {

    currentValidation = currentValidation.setIn([
      'comment', 'isValid'
    ], false).setIn([
      'comment', 'message'
    ], 'Complete Requires a comment.');
  }


  return currentValidation;

};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/closeCommentValidator.js